import { BasePill } from "./BasePill";
import { PillProps } from "./types";

export const WarningPill = ({
  children,
  variant = "DEFAULT",
  ...props
}: PillProps) => {
  return (
    <BasePill {...props} type="WARNING" variant={variant}>
      {children}
    </BasePill>
  );
};
